import { type MCPServerInfo } from '../../types';

const VegaServer: MCPServerInfo = {
  serverId: 'VEGA',
  name: 'Vega',
  slug: 'vega',
  description:
    "Vega Security's official MCP server — query federated SIEMs, data lakes, and endpoints with natural language.",
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.vega.io/mcp'
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: { required: [], properties: {} },
  installConfig: {
    required: ['vegaApiToken', 'vegaAccessKeyName'],
    properties: {
      vegaApiToken: {
        type: 'string',
        description:
          'Vega API access key (Settings → Access keys). Forwarded as the Authorization: Bearer header.',
        sensitive: true
      },
      vegaAccessKeyName: {
        type: 'string',
        description:
          'Name of the Vega access key. Forwarded as the X-Vega-Key-Id header on every request.',
        sensitive: false
      }
    }
  }
};

export default VegaServer;
